import * as React from "react";
const SvgFiRrQueueSignal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-queue-signal_svg__a)">
      <path
        fill="#062147"
        d="M6.538 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M14 10v3c0 1.474-.81 2.75-2 3.444V23a1 1 0 1 1-2 0v-6H8v6a1 1 0 1 1-2 0v-6H4v6a1 1 0 1 1-2 0v-6.556C.81 15.75 0 14.474 0 13v-3c0-2.032 1.529-3.697 3.494-3.949A5.97 5.97 0 0 0 2 10v3c0 1.103.897 2 2 2h.556A3.96 3.96 0 0 1 4 13v-3c0-2.206 1.794-4 4-4h2c2.206 0 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2H8c-1.103 0-2 .897-2 2v3c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2zM5 5c.085 0 .165-.017.248-.025a4.465 4.465 0 0 1 0-4.95C5.165.017 5.085 0 5 0a2.5 2.5 0 1 0 0 5m16 5v12h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2V10c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v4c0 1.654-1.346 3-3 3m-2-2h2c.552 0 1-.449 1-1V3c0-.551-.448-1-1-1h-2c-.552 0-1 .449-1 1v4c0 .551.448 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-queue-signal_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrQueueSignal;
